import React from 'react'
import { usePage } from '@inertiajs/inertia-react'
import Layout from '../../../Shared/Layout/LayoutAdmin'
import LayoutSiaLearner from '../../../Shared/Layout/LayoutSiaLearner'
import { SIA_GOLD_ACTIVE_BG, SIA_NAVY } from '../../../constants/siaTheme'

const Grades = ({ rows, pending, total_exams: totalExams, final_score: finalScore, passing_score: passingScore }) => {
    const { sia_use_learner_layout: learnerLayout } = usePage().props

    return (
        <div className={'d-flex justify-content-center px-2 ' + (learnerLayout ? 'pb-10 pt-2' : 'pb-10 mt-5')}>
            <div className="w-100" style={{ maxWidth: '880px' }}>
                <div className="rounded-3 shadow-sm bg-white overflow-hidden" style={{ border: '1px solid #e8e8e8' }}>
                    <div className="text-center text-white py-5 px-4" style={{ backgroundColor: SIA_NAVY }}>
                        <div className="text-uppercase fw-bold fs-3" style={{ letterSpacing: '0.06em' }}>Calificación final</div>
                        <div className="opacity-75 mt-2">Resultados de los exámenes que ya presentaste</div>
                    </div>
                    <div className="px-6 px-md-10 py-8">
                        {finalScore === null ? (
                            <p className="text-gray-700 fs-5">
                                El resultado global aparece cuando hayas presentado los {totalExams} exámenes.
                                {pending > 0 ? ` Te faltan ${pending}.` : ''}
                            </p>
                        ) : (
                            <div className="text-center rounded-3 py-6 mb-8" style={{ backgroundColor: '#fbf6e8', border: '1px solid #e6d48a' }}>
                                <div className="text-uppercase fw-semibold" style={{ color: '#8a7014', letterSpacing: '0.06em' }}>Resultado global</div>
                                <div className="fw-bold" style={{ fontSize: '3.5rem', lineHeight: 1.1, color: SIA_NAVY }}>{finalScore}</div>
                                <div className="text-gray-600">Promedio de todos los exámenes. Cada uno aprueba con {passingScore} o más.</div>
                            </div>
                        )}

                        {rows.length === 0 ? (
                            <p className="text-gray-600 mb-0">Todavía no presentas ningún examen.</p>
                        ) : (
                            <div className="d-flex flex-column gap-4">
                                {rows.map((row) => (
                                    <div key={`${row.section}-${row.title}`} className="rounded-3 p-5" style={{ border: '1px solid #e4e6ef' }}>
                                        <div className="d-flex justify-content-between align-items-start gap-3">
                                            <div>
                                                {row.parent && <div className="text-gray-500 fs-7 text-uppercase">{row.parent}</div>}
                                                <div className="fw-bold fs-5 text-gray-900">{row.section}</div>
                                                <div className="text-gray-600">{row.title}</div>
                                            </div>
                                            <div className="text-end">
                                                <div className="fw-bold fs-2" style={{ color: SIA_NAVY }}>{row.score}</div>
                                                <div className="fw-semibold" style={{ color: row.passed ? '#0f7a3a' : '#9b2c2c' }}>
                                                    {row.abandoned ? 'Incompleto' : row.passed ? 'Aprobado' : 'No aprobado'}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="text-gray-500 fs-7 mt-2">
                                            {row.abandoned
                                                ? `Saliste del examen. Calificación 0. · ${row.finished_at}`
                                                : `${row.correct_count} de ${row.question_count} · ${row.finished_at}`}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
                <div className="d-none" style={{ backgroundColor: SIA_GOLD_ACTIVE_BG }} />
            </div>
        </div>
    )
}

Grades.layout = (page) => {
    if (page.props.sia_use_learner_layout) {
        return <LayoutSiaLearner title="Calificación final | SIA">{page}</LayoutSiaLearner>
    }
    return <Layout title="Calificación final">{page}</Layout>
}

export default Grades
